export default {
  'pages.layouts.userLayout.title': 'Hello!',
  'pages.404.subTitle': 'Sorry, the page you visited does not exist.',
  'pages.404.buttonText': 'Back to Home',

  // Common
  'pages.common.create': 'Create',
  'pages.common.edit': 'Edit',
  'pages.common.delete': 'Delete',
  'pages.common.detail': 'Detail',
  'pages.common.status': 'Status',
  'pages.common.actions': 'Actions',
  'pages.common.search': 'Search',
  'pages.common.reset': 'Reset',
  'pages.common.export': 'Export',
  'pages.common.download': 'Download',
  'pages.common.refresh': 'Refresh',
  'pages.common.confirm': 'Confirm',
  'pages.common.cancel': 'Cancel',
  'pages.common.retry': 'Retry',
  'pages.common.replay': 'Replay',
  'pages.common.resend': 'Resend',
  'pages.common.copy': 'Copy',
  'pages.common.copySuccess': 'Copied to clipboard',

  // P-01
  'pages.dashboard.title': 'Dashboard',
  'pages.dashboard.overview': 'EDI Operational Dashboard',
  'pages.dashboard.desc':
    "Real-time monitoring of today's total traffic, success rate, error distribution, and partner status.",
  'pages.dashboard.filter.timeRange': 'Time Range',
  'pages.dashboard.filter.today': 'Today (24h)',
  'pages.dashboard.filter.7days': 'Last 7 Days',
  'pages.dashboard.filter.30days': 'Last 30 Days',
  'pages.dashboard.metric.todayTotal': 'Today Total Volume',
  'pages.dashboard.metric.inbound': 'Inbound',
  'pages.dashboard.metric.outbound': 'Outbound',
  'pages.dashboard.metric.successRate': 'Success Rate',
  'pages.dashboard.metric.errorCount': 'Error Messages',
  'pages.dashboard.metric.onlinePartners': 'Active Partners',
  'pages.dashboard.metric.activePartners': 'Active Partners',
  'pages.dashboard.metric.activeRate': 'Active Rate',
  'pages.dashboard.metric.enabledCount': '{count} Enabled',
  'pages.dashboard.metric.yoy': 'vs Yesterday Same Time',
  'pages.dashboard.trend.title': 'Traffic Trend',
  'pages.dashboard.trend.chartTitle': 'Traffic Trend Chart',
  'pages.dashboard.trend.inboundLegend': 'Inbound',
  'pages.dashboard.trend.outboundLegend': 'Outbound',
  'pages.dashboard.errorDist.title': 'Error Distribution',
  'pages.dashboard.errorDist.chartTitle': 'Error Distribution Chart',
  'pages.dashboard.errorDist.totalError': 'Total Errors',
  'pages.dashboard.errorDist.empty': 'No error data',
  'pages.dashboard.partnerStatus.title': 'Partner Status',
  'pages.dashboard.partnerStatus.pinned': 'Pinned Warning',
  'pages.dashboard.partnerStatus.partnerName': 'Partner Name',
  'pages.dashboard.partnerStatus.protocol': 'Protocol',
  'pages.dashboard.partnerStatus.lastComm': 'Last Communication',
  'pages.dashboard.partnerStatus.todayVol': 'Today Traffic',
  'pages.dashboard.partnerStatus.rate': 'Success Rate',
  'pages.dashboard.partnerStatus.status': 'Status',
  'pages.dashboard.partnerStatus.healthy': 'Normal',
  'pages.dashboard.partnerStatus.warning': 'Abnormal',
  'pages.dashboard.partnerStatus.idle': 'No Traffic',
  'pages.dashboard.partnerStatus.disabled': 'Disabled',
  'pages.dashboard.todos.title': 'Unresolved Failed Messages',
  'pages.dashboard.todos.failedTotal': 'Unresolved Failures',
  'pages.dashboard.todos.viewAll': 'View All',
  'pages.dashboard.todos.empty': 'No unresolved failed messages',
  'pages.dashboard.todos.unhandledAlerts': 'High Priority Alerts',
  'pages.dashboard.todos.overdueWorkorders': 'Overdue Workorders',
  'pages.dashboard.todos.occurrence': '{count} occurrences',
  'pages.dashboard.todos.overdue': 'Overdue by {min} mins',
  'pages.dashboard.todos.viewAllAlerts': 'View All Alerts',
  'pages.dashboard.todos.viewAllWorkorders': 'View All Workorders',

  'pages.common.noPermission': 'No operation permission',

  // P-02
  'pages.access.partners.title': 'Partners',
  'pages.access.partners.desc':
    'Manage carriers, terminals, depots, and internal systems protocols and receipt level configurations.',
  'pages.access.partners.create': 'New Partner',
  'pages.access.partners.searchPlaceholder': 'Search partner name / code',
  'pages.access.partners.colName': 'Partner Name',
  'pages.access.partners.colCode': 'Partner Code',
  'pages.access.partners.colType': 'Type',
  'pages.access.partners.colProtocols': 'Enabled Protocols',
  'pages.access.partners.colReceipts': 'Declared Receipt Levels',
  'pages.access.partners.colStatus': 'Status',
  'pages.access.partners.colConnectivity': 'Connectivity Test',
  'pages.access.partners.colLastComm': 'Last Communication',
  'pages.access.partners.type.carrier': 'Carrier',
  'pages.access.partners.type.port': 'Port / Terminal',
  'pages.access.partners.type.yard': 'Logistics Yard',
  'pages.access.partners.type.railway': 'Railway',
  'pages.access.partners.type.internal': 'Internal System',
  'pages.access.partners.status.draft': 'Draft',
  'pages.access.partners.status.pendingReview': 'Pending Review',
  'pages.access.partners.status.enabled': 'Enabled',
  'pages.access.partners.status.disabled': 'Disabled',
  'pages.access.partners.testConnectivity': 'Test Connectivity',
  'pages.access.partners.testingConnectivity': 'Testing...',
  'pages.access.partners.testSuccess':
    'Connectivity test passed! Latency: {latency}ms',
  'pages.access.partners.testFailed': 'Connectivity test failed',
  'pages.access.partners.enable': 'Enable',
  'pages.access.partners.disable': 'Disable',
  'pages.access.partners.submitReview': 'Submit for Review',
  'pages.access.partners.enableDisabledUntested':
    'Cannot enable: connectivity test has not passed yet.',
  'pages.access.partners.disableConfirmTitle': 'Confirm Partner Deactivation',
  'pages.access.partners.disableConfirmImpact':
    'Deactivating this partner will immediately interrupt all EDI exchanges on related channels.',
  'pages.access.partners.disableSuccess': 'Partner disabled successfully',
  'pages.access.partners.enableSuccess': 'Partner enabled successfully',
  'pages.access.partners.submitReviewSuccess':
    'Access request submitted for review',
  'pages.access.partners.emptyDesc':
    'No partners found. Create your first carrier or terminal partner.',
  'pages.access.partners.createTitle': 'New Partner',
  'pages.access.partners.step1': 'Basic Info',
  'pages.access.partners.step2': 'Protocols & Channels',
  'pages.access.partners.step3': 'Receipts & Timeouts',
  'pages.access.partners.step4': 'Permissions & Activation',
  'pages.access.partners.createSuccess': 'Partner created successfully',
  'pages.access.partners.tested': 'Passed',
  'pages.access.partners.untested': 'Untested',
  'pages.access.partners.status.underReview': 'Under Review',
  'pages.access.partners.type.carrierFull': 'Carrier (Carrier)',
  'pages.access.partners.type.portFull': 'Port Terminal (Port)',
  'pages.access.partners.type.yardFull': 'Logistics Yard (Yard)',
  'pages.access.partners.type.railwayFull':
    'Railway Combined Transport (Railway)',
  'pages.access.partners.type.internalFull': 'Internal System (Internal)',
  'pages.access.partners.protocol.ftpCompat': 'FTP (Compatibility)',
  'pages.access.partners.initialStatus.draft': 'Save as Draft (DRAFT)',

  // P-03
  'pages.access.partnerDetail.title': 'Partner Detail',
  'pages.access.partnerDetail.desc':
    'Configure protocol channels, receipt levels, timeouts, bound standards, and certificates.',
  'pages.access.partnerDetail.backToList': 'Back to Partners',
  'pages.access.partnerDetail.tabProtocols': 'Protocols & Channels',
  'pages.access.partnerDetail.tabReceipts': 'Receipt Levels Configuration',
  'pages.access.partnerDetail.tabStandards': 'Standards & Mappings',
  'pages.access.partnerDetail.tabCertificates': 'Certificates',
  'pages.access.partnerDetail.tabHistory': 'Change History',
  'pages.access.partnerDetail.receiptNotice':
    'Notice: Undeclared receipt levels do not participate in timeout calculation or generate alerts.',
  'pages.access.partnerDetail.transportAck': 'Transport Ack',
  'pages.access.partnerDetail.transportAckDesc':
    'Corresponds to AS2 MDN, OFTP EERP, SFTP drop confirmation, or HTTP status response.',
  'pages.access.partnerDetail.syntaxAck': 'Syntax Ack',
  'pages.access.partnerDetail.syntaxAckDesc':
    'Corresponds to UN/EDIFACT CONTRL message for structural and syntax validation.',
  'pages.access.partnerDetail.appAck': 'Application Ack',
  'pages.access.partnerDetail.appAckDesc':
    'Corresponds to APERAK or carrier business acceptance response.',
  'pages.access.partnerDetail.timeoutMinutes': 'Timeout (Minutes)',
  'pages.access.partnerDetail.saveReceipts': 'Save Receipt Configuration',
  'pages.access.partnerDetail.saveReceiptsSuccess':
    'Receipt configuration saved successfully',
  'pages.access.partnerDetail.previewTitle':
    'Message Status Preview Under Current Declaration',
  'pages.access.partnerDetail.previewDesc':
    'Message tag preview according to declared receipt levels (undeclared levels are omitted):',
  'pages.access.partnerDetail.stdColName': 'Standard Name',
  'pages.access.partnerDetail.stdColVersion': 'Version',
  'pages.access.partnerDetail.stdColGray': 'Gray Status',
  'pages.access.partnerDetail.stdGrayYes': 'Gray Release',
  'pages.access.partnerDetail.stdGrayNo': 'Full Release',
  'pages.access.partnerDetail.viewStd': 'View Standard',
  'pages.access.partnerDetail.viewMapping': 'View Mapping',
  'pages.access.partnerDetail.histColTime': 'Change Time',
  'pages.access.partnerDetail.histColOperator': 'Operator',
  'pages.access.partnerDetail.histColField': 'Field Changed',
  'pages.access.partnerDetail.histColBefore': 'Before',
  'pages.access.partnerDetail.histColAfter': 'After',
  'pages.access.partnerDetail.histColIp': 'Client IP',
  'pages.access.partnerDetail.testResultTitle': 'Connectivity Test Log',
  'pages.access.partnerDetail.testResultSuccess': 'Test Passed',
  'pages.access.partnerDetail.testResultLatency': 'Latency: {latency}ms',
  'pages.access.partnerDetail.testResultCert':
    'Cert Fingerprint: {fingerprint}',
  'pages.access.partnerDetail.testResultTime': 'Tested At: {time}',
  'pages.access.partnerDetail.protocolCard': 'Protocol Configuration Card',
  'pages.access.partnerDetail.timeoutLabel': 'Timeout:',
  'pages.access.partnerDetail.previewSent': 'SENT:',
  'pages.access.partnerDetail.previewDelivered': 'DELIVERED:',
  'pages.access.partnerDetail.previewTimeout': 'Ack Timeout Scenario:',
  'pages.access.partnerDetail.boundStandardsTitle': 'Bound Message Standards',
  'pages.access.partnerDetail.relatedRulesTitle': 'Associated Mapping Rules',

  // P-04
  'pages.access.channels.title': 'Channels',
  'pages.access.channels.desc':
    'Manage local transport channels and protocol settings; partner endpoints and agreements are configured on each partner.',
  'pages.access.channels.resourcesTab': 'Channels',
  'pages.access.channels.localProtocolsTab': 'Local Protocol Settings',
  'pages.access.channels.create': 'New Channel',
  'pages.access.channels.allProtocols': 'All Protocols',
  'pages.access.channels.health.healthy': 'Healthy',
  'pages.access.channels.health.warning': 'Warning',
  'pages.access.channels.health.down': 'Down',
  'pages.access.channels.boundPartners': 'Bound Partners',
  'pages.access.channels.todayTraffic': 'Today Traffic',
  'pages.access.channels.lastHeartbeat': 'Last Heartbeat',
  'pages.access.channels.failoverTitle': 'High Availability & Failover',
  'pages.access.channels.primaryChannel': 'Primary Channel',
  'pages.access.channels.backupChannel': 'Backup Channel',
  'pages.access.channels.strategy': 'Strategy',
  'pages.access.channels.strategyAuto': 'Auto Failover',
  'pages.access.channels.strategyManual': 'Manual Failover',
  'pages.access.channels.primaryChannelLabel': 'Primary: ',
  'pages.access.channels.backupChannelLabel': 'Backup: ',
  'pages.access.channels.protocol.ftpLegacy': 'FTP (Legacy)',
  'pages.access.channels.strategyAutoFull':
    'Auto Failover on Ping Failure (Auto)',
  'pages.access.channels.strategyManualFull':
    'Manual Failover with Confirmation (Manual)',
  'pages.access.channels.lastSwitch': 'Last Switch Record',
  'pages.access.channels.switchedAt': 'Switched At',
  'pages.access.channels.switchReason': 'Reason',
  'pages.access.channels.duration': 'Duration',
  'pages.access.channels.recoveryStatus': 'Recovery Status',
  'pages.access.channels.recovered': 'Recovered',
  'pages.access.channels.inFailover': 'In Failover',
  'pages.access.channels.ping': 'Ping / Test',
  'pages.access.channels.pinging': 'Testing...',
  'pages.access.channels.pingSuccess':
    'Channel ping successful! Latency: {latency}ms',
  'pages.access.channels.switchHistory': 'Switch History',
  'pages.access.channels.emptyDesc':
    'No channels found. Add your first transmission channel.',
  'pages.access.channels.createTitle': 'New Channel',
  'pages.access.channels.createSuccess': 'Channel created successfully',

  // P-05
  'pages.access.certificates.title': 'Certificates & Keys',
  'pages.access.certificates.desc':
    'Manage signing, encryption, and TLS certificates with expiration warnings, certificate creation, and revocation.',
  'pages.access.certificates.import': 'Import Certificate',
  'pages.access.certificates.generateCsr': 'Create Certificate',
  'pages.access.certificates.colName': 'Certificate Name',
  'pages.access.certificates.colPartner': 'Partner',
  'pages.access.certificates.colUsage': 'Usage',
  'pages.access.certificates.colMaterialType': 'Material type',
  'pages.access.certificates.colAlgorithm': 'Algorithm',
  'pages.access.certificates.colFingerprint': 'Fingerprint',
  'pages.access.certificates.colIssuer': 'Issuer',
  'pages.access.certificates.colValidity': 'Validity Period',
  'pages.access.certificates.colDaysRemaining': 'Days Remaining',
  'pages.access.certificates.colStatus': 'Status',
  'pages.access.certificates.usage.signing': 'Signing',
  'pages.access.certificates.usage.encryption': 'Encryption',
  'pages.access.certificates.usage.tls': 'TLS',
  'pages.access.certificates.usage.tlsMutual': 'Mutual TLS (mTLS)',
  'pages.access.certificates.samplePartnerHMM': 'HMM',
  'pages.access.certificates.samplePartnerMSC': 'MSC',
  'pages.access.certificates.samplePartnerMaersk': 'Maersk',
  'pages.access.certificates.samplePartnerCosco': 'COSCO Shipping',
  'pages.access.certificates.algo.rsa2048': 'RSA 2048',
  'pages.access.certificates.algo.rsa4096': 'RSA 4096',
  'pages.access.certificates.algo.sm2': 'SM2',
  'pages.access.certificates.generatedCsrTitle':
    'Generated Certificate Request (Please copy and submit to CA):',
  'pages.access.certificates.status.normal': 'Normal',
  'pages.access.certificates.status.expiringSoon': 'Expiring Soon',
  'pages.access.certificates.status.expired': 'Expired',
  'pages.access.certificates.status.revoked': 'Revoked',
  'pages.access.certificates.daysExpired': 'Expired {days} days ago',
  'pages.access.certificates.daysRemainingUrgent': '{days} days (Urgent)',
  'pages.access.certificates.daysRemainingWarning': '{days} days (Warning)',
  'pages.access.certificates.daysRemainingNormal': '{days} days',
  'pages.access.certificates.downloadPublicKey': 'Download Public Certificate',
  'pages.access.certificates.downloadPrivateKey':
    'Download Private Certificate',
  'pages.access.certificates.downloading': 'Downloading...',
  'pages.access.certificates.downloadSuccess':
    'Public key exported and downloaded',
  'pages.access.certificates.privateKeyNotice':
    'Security Notice: Private keys can only be exported as password-protected PFX files; the password is never stored.',
  'pages.access.certificates.rotate': 'Rotate',
  'pages.access.certificates.revoke': 'Revoke',
  'pages.access.certificates.revokeConfirmTitle':
    'Confirm Certificate Revocation',
  'pages.access.certificates.revokeConfirmImpact':
    'Revocation is irreversible. The linked partner routes will be disabled and must be reconfigured and retested before they can be enabled again.',
  'pages.access.certificates.revokeSuccess':
    'Certificate revoked and linked partner disabled',
  'pages.access.certificates.emptyDesc':
    'No certificates found. Import or create a certificate.',
  'pages.access.certificates.importSuccess':
    'Certificate imported successfully',
  'pages.access.certificates.csrSuccess':
    'Certificate request generated successfully',

  // P-06
  'pages.standards.library.title': 'Standards Library',
  'pages.standards.library.desc':
    'Unified management of UN/EDIFACT, GB/T, and custom standards with multi-versioning.',
  'pages.standards.library.create': 'New Standard',
  'pages.standards.library.derive': 'Derive Version',
  'pages.standards.library.import': 'Import Standard',
  'pages.standards.library.colCode': 'Code',
  'pages.standards.library.colName': 'Standard Name',
  'pages.standards.library.colSystem': 'System',
  'pages.standards.library.colVersion': 'Current Version',
  'pages.standards.library.colMsgType': 'Message Type',
  'pages.standards.library.colStatus': 'Status',
  'pages.standards.library.colPartners': 'Applicable Partners',
  'pages.standards.library.colUpdatedAt': 'Updated At',
  'pages.standards.library.system.unEdifact': 'UN/EDIFACT',
  'pages.standards.library.system.gbT': 'GB/T',
  'pages.standards.library.system.enterprise': 'Enterprise Custom',
  'pages.standards.library.status.draft': 'Draft',
  'pages.standards.library.status.reviewing': 'Reviewing',
  'pages.standards.library.status.published': 'Published',
  'pages.standards.library.status.archived': 'Archived',
  'pages.standards.library.defaultVersion': 'Default Version',
  'pages.standards.library.setDefault': 'Set as Default',
  'pages.standards.library.diff': 'Diff Comparison',
  'pages.standards.library.emptyDesc':
    'No message standards found. Create or import one.',
  'pages.standards.library.createSuccess': 'Standard created successfully',
  'pages.standards.library.deriveSuccess': 'New version derived successfully',
  'pages.standards.library.setDefaultSuccess': 'Default version updated',
  'pages.standards.library.versionHistory': 'Version History & Coexistence',
  'pages.standards.library.searchPlaceholder': 'Search standard code / name',

  // P-07
  'pages.standards.standardDetail.title': 'Standard Detail & Structure Editor',
  'pages.standards.standardDetail.desc':
    'Structure tree editor, node constraint configuration, and version release impact analysis.',
  'pages.standards.detail.back': 'Back to Library',
  'pages.standards.detail.version': 'Current Version',
  'pages.standards.detail.diffBtn': 'Version Diff',
  'pages.standards.detail.rulesSummary': 'Validation Rules Overview',
  'pages.standards.detail.publishBtn': 'Publish Standard',
  'pages.standards.detail.structureTree': 'Message Structure Tree',
  'pages.standards.detail.nodeProperties': 'Node Properties',
  'pages.standards.detail.fieldCode': 'Field Code',
  'pages.standards.detail.fieldName': 'Field Name',
  'pages.standards.detail.dataType': 'Data Type',
  'pages.standards.detail.length': 'Length',
  'pages.standards.detail.mandatory': 'Mandatory',
  'pages.standards.detail.required': 'Mandatory',
  'pages.standards.detail.optional': 'Optional',
  'pages.standards.detail.repeat': 'Max Repeat',
  'pages.standards.detail.valueRange': 'Value Range / Regex',
  'pages.standards.detail.dictBinding': 'Dictionary Binding',
  'pages.standards.detail.validationRule': 'Validation Rule',
  'pages.standards.detail.addNode': 'Add Child Node',
  'pages.standards.detail.deleteNode': 'Delete Node',
  'pages.standards.detail.saveProps': 'Save Node Properties',
  'pages.standards.detail.publishModalTitle': 'Confirm Standard Release',
  'pages.standards.detail.publishSuccess': 'Standard published successfully',
  'pages.standards.detail.nodeSaveSuccess': 'Node properties saved',
  'pages.standards.detail.rulesOverviewTitle': 'Validation Rules Overview',

  // P-08
  'pages.standards.messageType.title': 'Message Types',
  'pages.standards.messageType.desc':
    'Manage bidirectional mapping rules between standard formats and internal data models.',
  'pages.standards.messageType.create': 'New Message Type',
  'pages.standards.messageType.migrate': 'Version Migration',
  'pages.standards.messageType.copy': 'Copy',
  'pages.standards.messageType.designer': 'Design Rule',
  'pages.standards.messageType.colName': 'Message Type Name',
  'pages.standards.messageType.colDirection': 'Direction',
  'pages.standards.messageType.colSource': 'Source Standard & Version',
  'pages.standards.messageType.colTarget': 'Target Standard & Version',
  'pages.standards.messageType.colExternalEnd': 'External Standard End',
  'pages.standards.messageType.colInternalEnd': 'Internal Model End',
  'pages.standards.messageType.colSubscribers': 'Subscribers',
  'pages.standards.messageType.colCurrentVersion': 'Current Version',
  'pages.standards.messageType.colCode': 'Message Type Code',
  'pages.standards.messageType.colPartner': 'Bound Partner',
  'pages.standards.messageType.colStatus': 'Status',
  'pages.standards.messageType.colTestResult': 'Last Test Result',
  'pages.standards.messageType.colUpdatedAt': 'Updated At',
  'pages.standards.messageType.direction.inbound': 'Inbound',
  'pages.standards.messageType.direction.outbound': 'Outbound',
  'pages.standards.messageType.status.draft': 'Draft',
  'pages.standards.messageType.status.testing': 'Testing',
  'pages.standards.messageType.status.published': 'Published',
  'pages.standards.messageType.testResult.passed': 'Passed',
  'pages.standards.messageType.testResult.failed': 'Failed',
  'pages.standards.messageType.testResult.untested': 'Untested',
  'pages.standards.messageType.cannotPublishTip':
    'Last test result is Failed or Untested. Publishing is blocked until sample tests pass!',
  'pages.standards.messageType.publish': 'Publish',
  'pages.standards.messageType.publishSuccess': 'Message type published',
  'pages.standards.messageType.emptyDesc':
    'No message types yet. Create one first.',
  'pages.standards.messageType.copySuccess': 'Rule copied successfully',
  'pages.standards.messageType.migrateModalTitle': 'Batch Version Migration',
  'pages.standards.messageType.migrateSourceStd': 'Source Standard Version',
  'pages.standards.messageType.migrateTargetStd': 'Target Standard Version',
  'pages.standards.messageType.migrateNotice':
    'Migration will create a new draft rule version with rollback support. Regression tests are required before release.',
  'pages.standards.messageType.migrateSuccess':
    'Version migration task initiated',
  'pages.standards.messageType.createSuccess': 'Message type created',

  // P-09
  'pages.standards.mappingDesigner.title': 'Mapping Designer',
  'pages.standards.mappingDesigner.desc':
    'Three-column visual designer with source tree, mapping canvas, target tree, and regression tests.',

  // P-10
  'pages.standards.dictionaries.title': 'Code Dictionaries',
  'pages.standards.dictionaries.desc':
    'Maintain code dictionaries for ports, container types, and currencies with partner mappings.',
  'pages.standards.dict.title': 'Code Dictionaries',
  'pages.standards.dict.desc':
    'Maintain code dictionaries for ports, container types, and currencies with partner mappings.',
  'pages.standards.dict.categoryTree': 'Dictionary Categories',
  'pages.standards.dict.categoryPorts': 'Port Codes (UN/LOCODE)',
  'pages.standards.dict.categoryCntrs': 'Container Types (ISO 6346)',
  'pages.standards.dict.categoryCurrencies': 'Currency Codes (ISO 4217)',
  'pages.standards.dict.categoryUnits': 'Units of Measure (UNECE Rec 20)',
  'pages.standards.dict.categoryCarriers': 'Carrier Codes (SCAC / Carrier)',
  'pages.standards.dict.create': 'New Code Entry',
  'pages.standards.dict.import': 'Batch Import',
  'pages.standards.dict.export': 'Export Dictionary',
  'pages.standards.dict.colInternalCode': 'Internal Code',
  'pages.standards.dict.colInternalName': 'Internal Name',
  'pages.standards.dict.colExternalCodes': 'External Code Mappings (1:N)',
  'pages.standards.dict.colStandard': 'Standard Source',
  'pages.standards.dict.colStatus': 'Status',
  'pages.standards.dict.colUpdatedAt': 'Updated At',
  'pages.standards.dict.filterPartner': 'Filter by Partner',
  'pages.standards.dict.allPartners': 'All Partners',
  'pages.standards.dict.references': 'View References',
  'pages.standards.dict.referencesTitle': 'Referenced Mapping Rules',
  'pages.standards.dict.referencesDesc':
    'This dictionary code is referenced by the following EDI mapping rules:',
  'pages.standards.dict.emptyDesc':
    'No dictionary codes found. Create or import entries.',
  'pages.standards.dict.createSuccess':
    'Code dictionary entry created successfully',
  'pages.standards.dict.importSuccess': 'Batch import task submitted',
  'pages.standards.dict.exportNotice':
    'Export task created. You will be notified when ready for download.',
  'pages.standards.dict.oneToManyDesc':
    'One internal code can map to different external codes per partner, resolved automatically during processing.',

  // P-11
  'pages.messages.status.delivered': 'Delivered',
  'pages.messages.status.sent': 'Sent',
  'pages.messages.status.processed': 'Processed (not delivered)',
  'pages.messages.status.failed': 'Failed',
  'pages.messages.status.duplicate': 'Duplicate',
  'pages.messages.title': 'Message Query',
  'pages.messages.desc':
    'High-frequency message query with multi-dimensional filtering, orthogonal status badges, and batch operations.',
  'pages.messages.query.filterTitle': 'Advanced Filters',
  'pages.messages.query.direction': 'Direction',
  'pages.messages.query.allDirections': 'All Directions',
  'pages.messages.query.inbound': 'Inbound',
  'pages.messages.query.outbound': 'Outbound',
  'pages.messages.query.partner': 'Partner',
  'pages.messages.query.allPartners': 'All Partners',
  'pages.messages.query.msgType': 'Message Type',
  'pages.messages.query.msgId': 'Message ID',
  'pages.messages.query.msgIdPlaceholder': 'Enter full or partial Message ID',
  'pages.messages.query.docNo': 'Document No',
  'pages.messages.query.docNoPlaceholder': 'Order No / BL No / Container No',
  'pages.messages.query.processStatus': 'Processing Status',
  'pages.messages.query.transportAck': 'Transport ACK',
  'pages.messages.query.syntaxAck': 'Syntax ACK',
  'pages.messages.query.appAck': 'App ACK',
  'pages.messages.query.allAcks': 'All',
  'pages.messages.query.timeRange': 'Transfer Time',
  'pages.messages.query.hasError': 'Has Error',
  'pages.messages.query.hasErrorYes': 'Errors Only',
  'pages.messages.query.hasErrorNo': 'Success Only',
  'pages.messages.query.isReplay': 'Replay Generated',
  'pages.messages.query.isReplayYes': 'Replay Only',
  'pages.messages.query.isReplayNo': 'Exclude Replay',
  'pages.messages.query.col.msgId': 'Message ID',
  'pages.messages.query.col.direction': 'Direction',
  'pages.messages.query.col.partner': 'Partner',
  'pages.messages.query.col.msgType': 'Message Type',
  'pages.messages.query.col.docNo': 'Document No',
  'pages.messages.query.col.status': 'Dual Status',
  'pages.messages.query.col.attempt': 'Attempt',
  'pages.messages.query.col.transferTime': 'Transfer Time',
  'pages.messages.query.col.duration': 'Duration',
  'pages.messages.query.replayTag': 'Replay',
  'pages.messages.query.batchReplay': 'Batch Replay',
  'pages.messages.query.batchResend': 'Batch Resend',
  'pages.messages.query.batchPrecheckTitle': 'Batch Precheck Confirmation',
  'pages.messages.query.batchPrecheckDesc':
    'Executing on {total} messages: {eligible} eligible, {skipped} ineligible will be skipped.',
  'pages.messages.query.exportAsyncTitle': 'Export Query Results',
  'pages.messages.query.exportAsyncNotice':
    'Export task created (Task ID: {taskId}). You will be notified in the notification center once ready.',
  'pages.messages.query.downloadRaw': 'Download Raw',
  'pages.messages.query.viewDetail': 'View Detail',
  'pages.messages.query.selectedCount': '{count} messages selected',

  // P-13
  'pages.messages.documents.title': 'Reference Trace',
  'pages.messages.documents.desc':
    'Trace document lifecycle messages by booking number or B/L number with cutoff time alerts.',

  // P-12
  'pages.messages.detail.title': 'Message Detail',
  'pages.messages.detail.desc':
    'Read-only attempt timeline, raw payload segment highlighting, conversion comparison, and receipt details.',
  'pages.messages.detail.msgId': 'Message ID',
  'pages.messages.detail.direction': 'Direction',
  'pages.messages.detail.partner': 'Partner',
  'pages.messages.detail.msgType': 'Message Type',
  'pages.messages.detail.docNo': 'Document No',
  'pages.messages.detail.summaryHash': 'Summary Hash',
  'pages.messages.detail.transferTime': 'Transfer Time',
  'pages.messages.detail.duration': 'Total Duration',
  'pages.messages.detail.currentAttempt': 'Current Attempt',
  'pages.messages.detail.replayGeneratedTag': 'Replay Generated',
  'pages.messages.detail.rawNoContent': 'No raw message content',
  'pages.messages.detail.imoSolasCompliant': 'IMO SOLAS Compliant',
  'pages.messages.detail.relations.iftmbc': 'IFTMBC (Booking Request)',
  'pages.messages.detail.relations.confirmed': 'Confirmed',
  'pages.messages.detail.relations.iftmin': 'IFTMIN (Booking Change Request)',
  'pages.messages.detail.relations.current': 'Current',
  'pages.messages.detail.relations.vermas': 'VERMAS (VGM Declaration)',
  'pages.messages.detail.relations.pendingSend': 'Pending Send',
  'pages.messages.detail.btn.replay': 'Replay',
  'pages.messages.detail.btn.resend': 'Resend',
  'pages.messages.detail.btn.download': 'Download Raw',
  'pages.messages.detail.btn.createWorkorder': 'Create Workorder',
  'pages.messages.detail.timeline.title':
    'Processing Attempt Timeline (Immutable History)',
  'pages.messages.detail.timeline.readOnlyTag': 'Read-only',
  'pages.messages.detail.timeline.currentTag': 'Current',
  'pages.messages.detail.timeline.attemptTitle': 'Attempt {no}',
  'pages.messages.detail.timeline.stepDesc':
    'Duration {ms}ms | Standard: {std} | Mapping: {map}',
  'pages.messages.detail.timeline.errorInfo':
    'Error Code: {code} | Reason: {msg}',
  'pages.messages.detail.tab.raw': 'Raw Payload',
  'pages.messages.detail.tab.rawText': 'Raw Plaintext View',
  'pages.messages.detail.tab.rawSegments': 'Segment Highlighted View',
  'pages.messages.detail.tab.transform': 'Structured Transform View',
  'pages.messages.detail.tab.validation': 'Compliance Validation',
  'pages.messages.detail.tab.receipts': 'Receipt Details',
  'pages.messages.detail.tab.relations': 'Related Messages',
  'pages.messages.detail.tab.audit': 'Operation Audit Logs',
  'pages.messages.detail.modal.replayTitle': 'Confirm Replay Message',
  'pages.messages.detail.modal.replayDesc':
    'Replay creates a new attempt node on the immutable timeline. Historical attempts remain read-only.',
  'pages.messages.detail.modal.resendTitle': 'Confirm Resend Message',
  'pages.messages.detail.modal.resendDesc':
    'The system has checked idempotency. The message will be resent via the transmission channel.',
  'pages.messages.detail.modal.reason': 'Reason & Approval Note',
  'pages.messages.detail.modal.reasonPlaceholder':
    'Enter business reason or ticket ID',
  'pages.messages.detail.modal.standardVersion': 'Select Standard Snapshot',
  'pages.messages.detail.modal.modifyPayload': 'Modify payload before replay',

  // P-14
  'pages.alerts.events.title': 'Alert Events',
  'pages.alerts.events.desc':
    'Real-time aggregated alert events with occurrence folding and quick workorder creation.',

  // P-15
  'pages.alerts.rules.title': 'Alert Rules',
  'pages.alerts.rules.desc':
    'Configure transmission error, validation failure, and cutoff time rules with noise warnings.',

  // P-16
  'pages.alerts.workorders.title': 'Incident Workorders',
  'pages.alerts.workorders.desc':
    'Incident investigation and closure with SLA countdown and append-only activity history.',

  // P-17

  // P-18

  // P-19

  // P-20
  'pages.audit.logs.title': 'Operation Audit',
  'pages.audit.logs.desc':
    'Immutable audit logging for operator actions with row-expandable before-and-after diffs.',
  'pages.audit.logs.bannerTitle': 'Immutable Audit Log & Hash-chain Integrity',
  'pages.audit.logs.bannerDesc':
    'All operation logs are stored via WORM (Write Once, Read Many) with cryptographic hash-chain anchoring (Verified: Cannot be deleted or modified).',
  'pages.audit.logs.colTime': 'Timestamp',
  'pages.audit.logs.colOperator': 'Operator',
  'pages.audit.logs.colOrg': 'Organization',
  'pages.audit.logs.colType': 'Action Type',
  'pages.audit.logs.colTarget': 'Target Object',
  'pages.audit.logs.colIp': 'Client IP',
  'pages.audit.logs.colResult': 'Result',
  'pages.audit.logs.colHash': 'Integrity',
  'pages.audit.logs.hashVerified': 'Hash Verified',
  'pages.audit.logs.hashFailed': 'Integrity Anomaly',
  'pages.audit.logs.diffTitle': 'Before / After Data Comparison (Diff View)',
  'pages.audit.logs.diffBefore': 'Before Change',
  'pages.audit.logs.diffAfter': 'After Change',
  'pages.audit.logs.diffNoData': 'No before/after snapshot data recorded',
  'pages.audit.logs.emptyText': 'No audit logs found',
  'pages.audit.logs.filterTime': 'Time Range',
  'pages.audit.logs.filterOperator': 'Operator',
  'pages.audit.logs.filterType': 'Action Type',
  'pages.audit.logs.filterResult': 'Result',
  'pages.audit.logs.immutableNotice':
    'Audit logs are permanently archived in read-only storage. Deletion is prohibited.',

  // P-21
  'pages.audit.reports.title': 'Audit Reports',
  'pages.audit.reports.desc':
    'Configure scheduled report templates and export volume, SLA compliance, and security logs.',
  'pages.audit.reports.tabTemplates': 'Report Templates',
  'pages.audit.reports.tabGenerated': 'Generated Reports',
  'pages.audit.reports.createTemplateBtn': 'New Report Template',
  'pages.audit.reports.colTplName': 'Template Name',
  'pages.audit.reports.colTplType': 'Report Type',
  'pages.audit.reports.colTplPeriod': 'Period',
  'pages.audit.reports.colTplScope': 'Scope',
  'pages.audit.reports.colTplRecipients': 'Recipients',
  'pages.audit.reports.colTplStatus': 'Status',
  'pages.audit.reports.actionGenerateNow': 'Generate Now',
  'pages.audit.reports.actionEdit': 'Edit',
  'pages.audit.reports.generateTaskNotice':
    'Report generation task created. Notification will alert when ready for download.',
  'pages.audit.reports.colGenName': 'Report Name',
  'pages.audit.reports.colGenPeriod': 'Period',
  'pages.audit.reports.colGenTime': 'Generated Time',
  'pages.audit.reports.colGenRange': 'Data Range',
  'pages.audit.reports.colGenFormat': 'Format',
  'pages.audit.reports.colGenSize': 'File Size',
  'pages.audit.reports.actionDownload': 'Download',
  'pages.audit.reports.downloadNotice': 'Report download initiated.',
  'pages.audit.reports.emptyTemplates': 'No report templates configured',
  'pages.audit.reports.emptyTemplatesAction': 'Create First Template',
  'pages.audit.reports.emptyGenerated': 'No generated reports found',
  'pages.audit.reports.modalTitle': 'Create Report Template',
  'pages.audit.reports.modalName': 'Template Name',
  'pages.audit.reports.modalType': 'Report Type',
  'pages.audit.reports.modalPeriod': 'Period',
  'pages.audit.reports.modalScope': 'Scope',
  'pages.audit.reports.modalRecipients': 'Recipients (comma separated)',
  'pages.audit.reports.createSuccess': 'Report template created successfully',
  'pages.audit.reports.typeStats': 'Message Volume & Timeliness',
  'pages.audit.reports.typeErrors': 'Anomaly Analysis & SLA',
  'pages.audit.reports.typeAudit': 'Operation Log & Security Audit',
  'pages.audit.reports.typeCompliance': 'Compliance & Rule Validation',
  'pages.audit.reports.periodDaily': 'Daily',
  'pages.audit.reports.periodWeekly': 'Weekly',
  'pages.audit.reports.periodMonthly': 'Monthly',
  'pages.audit.reports.periodQuarterly': 'Quarterly',

  'pages.standards.library.uploadText':
    'Click or drag schema definition file (XSD / JSON Schema / EDIFACT DEF) here',
  'pages.standards.library.uploadHint':
    'Supports UN/EDIFACT directories, GB/T specs, and custom packages',
  'pages.standards.library.baseVersion': 'Baseline Version',
  'pages.standards.library.newVersion': 'Derived Version Number',
  'pages.standards.library.versionNotes': 'Version Change Notes',
  'pages.standards.library.versionNotesPlaceholder':
    'Describe extensions and changes based on baseline...',
  'pages.standards.library.importSuccess':
    'Standard definition file parsed and imported successfully',
  'pages.standards.library.diffBase': 'Comparison Baseline',
  'pages.standards.library.newVersionPlaceholder': 'e.g. D.22B or v2.1',
  'pages.standards.detail.segment': 'Segment',
  'pages.standards.detail.segmentGroup': 'Segment Group',
  'pages.standards.detail.composite': 'Composite Element',
  'pages.standards.detail.element': 'Data Element',
  'pages.standards.detail.selectNodeTip':
    'Please select a node on the left tree to view and edit attributes',
  'pages.standards.detail.diffTitle': 'Version Diff Comparison',
  'pages.standards.detail.diffComparedVersion': 'Compared Version',
  'pages.standards.detail.ruleName': 'Rule Name',
  'pages.standards.detail.ruleType': 'Validation Type',
  'pages.standards.detail.ruleDesc': 'Rule Description',
  'pages.standards.dict.categoryAll': 'All Categories',
  'pages.standards.dict.importModalTitle':
    'Batch Import Code Dictionary (Excel)',
  'pages.standards.dict.uploadFileTip':
    'Click or drag Excel file (.xlsx, .xls) here to import',
  'pages.standards.dict.uploadFileHint':
    'Supports multi-column mappings between internal and partner codes',
  'pages.standards.dict.sampleRefRule':
    'Maersk Booking Confirmation Mapping (map-01)',
  'pages.standards.dict.edit': 'Edit',

  'pages.standards.detail.typeAn': 'AN (Alphanumeric)',
  'pages.standards.detail.typeN': 'N (Numeric)',
  'pages.standards.detail.noDict': 'No Dictionary',

  'pages.standards.messageType.migrateOption1':
    'UN/EDIFACT IFTMBC D.99B (2 rules currently)',
  'pages.standards.messageType.migrateOption2':
    'UN/EDIFACT IFTMBF D.00B (1 rule currently)',
  'pages.standards.messageType.migrateTargetOption1':
    'UN/EDIFACT IFTMBC D.00B (Latest Published)',
  'pages.standards.messageType.migrateTargetOption2':
    'UN/EDIFACT IFTMBF D.21A (Latest Draft)',

  'pages.standards.dict.samplePartnerCosco': 'COSCO SHIPPING',
  'pages.standards.dict.colRefRule': 'Mapping Rule',
  'pages.standards.dict.colBoundField': 'Bound Field',
  'pages.standards.dict.colMapFunction': 'Mapping Function',

  // P-13 单号追溯
  'pages.messages.documents.disclaimerTitle':
    'Business Sequence Clarification Notice',
  'pages.messages.documents.disclaimerDesc':
    'The business sequence on this page is an illustrative maritime convention flow (Booking Request -> Confirm -> Amend -> SI -> VGM -> B/L Confirm -> Container Tracking), subject to business confirmation (Item 1, Chapter 10 of Feature Specs).',
  'pages.messages.documents.searchLabel': 'Document No.',
  'pages.messages.documents.searchPlaceholder':
    'Please enter Booking No. or B/L No.',
  'pages.messages.documents.searchBtn': 'Search Document',
  'pages.messages.documents.resetBtn': 'Reset',
  'pages.messages.documents.quickSampleBtn':
    'Load Cancellation Version Chain Sample (Long No.)',
  'pages.messages.documents.docInfoTitle':
    'Current Document Status & Key Fields',
  'pages.messages.documents.businessDocNo': 'Business Doc No.',
  'pages.messages.documents.businessType': 'Business Type',
  'pages.messages.documents.carrierName': 'Carrier / Partner',
  'pages.messages.documents.vesselVoyage': 'Vessel / Voyage',
  'pages.messages.documents.portOfLoading': 'Port of Loading (POL)',
  'pages.messages.documents.portOfDischarge': 'Port of Discharge (POD)',
  'pages.messages.documents.containerSummary': 'Containers & Gross Weight',
  'pages.messages.documents.cutoffMonitoringTitle':
    'Carrier Cutoff Monitoring (M5-07)',
  'pages.messages.documents.siCutoff': 'SI Cutoff Time',
  'pages.messages.documents.vgmCutoff': 'VGM Cutoff Time',
  'pages.messages.documents.customsCutoff': 'Customs Cutoff Time',
  'pages.messages.documents.cutoffWarningTitle':
    'Cutoff Approaching Alert: Incomplete mandatory business actions',
  'pages.messages.documents.cutoffWarningDesc':
    'Document has been cancelled and approved; cutoff countdown is archived. For active bookings, incomplete actions within 180 mins trigger red alert.',
  'pages.messages.documents.timelineTitle':
    'Full Lifecycle Sequence & Message Track',
  'pages.messages.documents.viewMessageDetail': 'View Message Detail',
  'pages.messages.documents.inboundTag': 'Inbound',
  'pages.messages.documents.outboundTag': 'Outbound',
  'pages.messages.documents.versionLabel': 'Message Version',
  'pages.messages.documents.noteLabel': 'Processing Note',
  'pages.messages.documents.emptyText': 'No trace found for document number',
  'pages.messages.documents.statusBooked': 'Booking Confirmed',
  'pages.messages.documents.statusAmended': 'Amended',
  'pages.messages.documents.statusCancelled': 'Cancelled',

  // P-14 预警事件
  'pages.alerts.events.colEventNo': 'Event No.',
  'pages.alerts.events.colLevel': 'Level',
  'pages.alerts.events.colRuleName': 'Rule Name',
  'pages.alerts.events.colType': 'Alert Type',
  'pages.alerts.events.colPartner': 'Partner',
  'pages.alerts.events.colMessage': 'Related Message',
  'pages.alerts.events.colTriggeredAt': 'Triggered At',
  'pages.alerts.events.colDuration': 'Duration',
  'pages.alerts.events.colStatus': 'Status',
  'pages.alerts.events.colAssignee': 'Assignee',
  'pages.alerts.events.colDedupCount': 'Occurrence Count',
  'pages.alerts.events.colAction': 'Action',
  'pages.alerts.events.levelCritical': 'Critical',
  'pages.alerts.events.levelHigh': 'High',
  'pages.alerts.events.levelMedium': 'Medium',
  'pages.alerts.events.levelLow': 'Low',
  'pages.alerts.events.typeTransport': 'Transport Error',
  'pages.alerts.events.typeValidation': 'Validation Error',
  'pages.alerts.events.typeSystem': 'System Error',
  'pages.alerts.events.typeSla': 'SLA Timeout',
  'pages.alerts.events.statusUnhandled': 'Unhandled',
  'pages.alerts.events.statusHandling': 'Handling',
  'pages.alerts.events.statusResolved': 'Resolved',
  'pages.alerts.events.statusIgnored': 'Ignored',
  'pages.alerts.events.claimBtn': 'Claim',
  'pages.alerts.events.claimSuccess':
    'Alert claimed successfully and switched to Handling',
  'pages.alerts.events.ignoreBtn': 'Ignore',
  'pages.alerts.events.ignoreModalTitle': 'Ignore Alert Event',
  'pages.alerts.events.ignoreReasonLabel': 'Ignore Reason',
  'pages.alerts.events.ignoreReasonPlaceholder':
    'Please enter ignore reason (required)',
  'pages.alerts.events.ignoreSuccess': 'Alert marked as ignored',
  'pages.alerts.events.toWorkorderBtn': 'To Workorder',
  'pages.alerts.events.toWorkorderSuccess':
    'Workorder created successfully from alert event',
  'pages.alerts.events.viewRule': 'View Rule',
  'pages.alerts.events.foldedTag': 'Aggregated {count} times',
  'pages.alerts.events.expandDedupKey': 'Dedup Key',
  'pages.alerts.events.filterAll': 'All Statuses',
  'pages.alerts.events.filterDefaultView': 'Active Alerts (Unhandled/Handling)',
  'pages.alerts.events.empty': 'No matching alert events found',

  // P-15 预警规则
  'pages.alerts.rules.createBtn': 'Create Alert Rule',
  'pages.alerts.rules.colName': 'Rule Name',
  'pages.alerts.rules.colScenario': 'Scenario',
  'pages.alerts.rules.colTriggerMode': 'Trigger Mode',
  'pages.alerts.rules.triggerEvent': 'Event-driven',
  'pages.alerts.rules.triggerScheduled': 'Time-based',
  'pages.alerts.rules.triggerEventTip':
    'Triggered in real time when the exchange engine emits a parsing, validation, mapping, or transport error event',
  'pages.alerts.rules.triggerScheduledTip':
    'Continuously evaluated against receipt deadlines or business calendars',
  'pages.alerts.rules.colCondition': 'Condition Summary',
  'pages.alerts.rules.colNotifyChannels': 'Channels',
  'pages.alerts.rules.colNotifyTargets': 'Targets',
  'pages.alerts.rules.colSilentWindow': 'Silence Window',
  'pages.alerts.rules.colStatus': 'Status',
  'pages.alerts.rules.colLastTriggered': 'Last Triggered',
  'pages.alerts.rules.col7dCount': '7-Day Triggers',
  'pages.alerts.rules.colAction': 'Action',
  'pages.alerts.rules.editBtn': 'Edit',
  'pages.alerts.rules.noiseWarningTag':
    'High Noise: Threshold Adjustment Advised',
  'pages.alerts.rules.noiseWarningTooltip':
    'Triggered {count} times in the last 7 days. Exceptionally high frequency indicates threshold may be too sensitive. Consider broadening threshold or increasing silence window.',
  'pages.alerts.rules.minutesUnit': '{val} mins',
  'pages.alerts.rules.modalCreateTitle': 'Create Alert Rule',
  'pages.alerts.rules.modalEditTitle': 'Edit Alert Rule',
  'pages.alerts.rules.sectionBase': 'Basic Info & Condition',
  'pages.alerts.rules.sectionSlaSpecial':
    'Cutoff SLA Specific Config (M5-07 Cutoff Clock & Calendar)',
  'pages.alerts.rules.sectionNotify': 'Silence, Notification & Escalation',
  'pages.alerts.rules.fieldScenario': 'Scenario',
  'pages.alerts.rules.fieldName': 'Rule Name',
  'pages.alerts.rules.fieldCondition': 'Condition Expression',
  'pages.alerts.rules.fieldDedupKey': 'Dedup Key Template',
  'pages.alerts.rules.fieldSilent': 'Silence Window (minutes)',
  'pages.alerts.rules.fieldChannels': 'Notification Channels',
  'pages.alerts.rules.fieldTargets': 'Notification Targets',
  'pages.alerts.rules.fieldEscalation': 'Escalation Path',
  'pages.alerts.rules.fieldRecovery': 'Auto Recovery Condition',
  'pages.alerts.rules.fieldCalendar': 'Cutoff Calendar',
  'pages.alerts.rules.fieldTimezone': 'Base Timezone',
  'pages.alerts.rules.fieldAdvanceWindow': 'Advance Warning Window (minutes)',
  'pages.alerts.rules.saveSuccess': 'Alert rule saved successfully',
  'pages.alerts.rules.toggleSuccess': 'Rule status updated',
  'pages.alerts.rules.empty': 'No alert rules found, click to create',
  'pages.alerts.rules.optScenario1': 'Outbound Transport Monitoring',
  'pages.alerts.rules.optScenario2': 'Inbound Message Parsing',
  'pages.alerts.rules.optScenario3': 'Cutoff SLA Calendar Monitoring',
  'pages.alerts.rules.optScenario4': 'Mandatory Elements Syntax Validation',
  'pages.alerts.rules.optTzUtc': 'UTC (Coordinated Universal Time)',

  // P-16 异常工单
  'pages.alerts.workorders.createBtn': 'Create Workorder',
  'pages.alerts.workorders.colNo': 'Workorder No.',
  'pages.alerts.workorders.colTitle': 'Title',
  'pages.alerts.workorders.colSource': 'Source',
  'pages.alerts.workorders.colRelated': 'Related Message / Event',
  'pages.alerts.workorders.colPriority': 'Priority',
  'pages.alerts.workorders.colAssignee': 'Assignee',
  'pages.alerts.workorders.colStatus': 'Status',
  'pages.alerts.workorders.colCreatedAt': 'Created At',
  'pages.alerts.workorders.colSlaRemaining': 'SLA Remaining',
  'pages.alerts.workorders.colDuration': 'Process Duration',
  'pages.alerts.workorders.colAction': 'Action',
  'pages.alerts.workorders.slaOverdueTag': 'Overdue by {min} mins',
  'pages.alerts.workorders.slaWarningTag':
    '{min} mins left (Imminent Breaching)',
  'pages.alerts.workorders.slaNormalTag': '{min} mins left',
  'pages.alerts.workorders.sourceAuto': 'Auto Alert',
  'pages.alerts.workorders.sourceManual': 'Manual',
  'pages.alerts.workorders.statusPendingAssign': 'Pending Assign',
  'pages.alerts.workorders.statusProcessing': 'Processing',
  'pages.alerts.workorders.statusPendingVerify': 'Pending Verify',
  'pages.alerts.workorders.statusClosed': 'Closed',
  'pages.alerts.workorders.viewDetailBtn': 'Detail',
  'pages.alerts.workorders.drawerTitle': 'Workorder Details & Audit Trail',
  'pages.alerts.workorders.baseInfoCard': 'Basic Information',
  'pages.alerts.workorders.relatedObjectCard': 'Related Objects',
  'pages.alerts.workorders.historyNotice':
    'History logs are immutable audit traces. Only append-only updates under current operator session are supported.',
  'pages.alerts.workorders.appendRecordBtn': 'Append Log Record',
  'pages.alerts.workorders.appendPlaceholder':
    'Enter troubleshooting notes, communication conclusions, or fixes...',
  'pages.alerts.workorders.appendSuccess': 'Log record appended successfully',
  'pages.alerts.workorders.closeBtn': 'Close Workorder',
  'pages.alerts.workorders.closeModalTitle':
    'Close Workorder (Closing Basis Required)',
  'pages.alerts.workorders.closeReasonLabel': 'Closing Basis & Root Cause',
  'pages.alerts.workorders.closeReasonPlaceholder':
    'Please specify closing basis, root cause analysis, and preventive measures (required)',
  'pages.alerts.workorders.closeSuccess': 'Workorder closed successfully',
  'pages.alerts.workorders.empty': 'No workorders found',
  'pages.alerts.workorders.optP0': 'P0 (Critical)',
  'pages.alerts.workorders.optP1': 'P1 (High)',
  'pages.alerts.workorders.optP2': 'P2 (Medium)',
  'pages.alerts.workorders.optP3': 'P3 (Low)',
  'pages.alerts.workorders.slaOverdueAlertDesc':
    'This workorder has breached SLA. Escalated to responsible architect.',
  'pages.alerts.workorders.slaWarningAlertDesc':
    'Workorder approaching SLA threshold. Accelerate troubleshooting.',

  // P-09

  // P-08
  'pages.standards.messageType.diffTitle':
    'Field-Level Diff Preview & Impact Assessment',
  'pages.standards.messageType.affectedRulesCount': 'Affects 2 mapping rules',
  'pages.standards.messageType.diffColType': 'Diff Type',
  'pages.standards.messageType.diffColField': 'Field & Name',
  'pages.standards.messageType.diffColOld': 'Old Spec (D.99B)',
  'pages.standards.messageType.diffColNew': 'New Spec (D.00B)',
  'pages.standards.messageType.diffColImpact': 'Rule Impact',
  'pages.standards.messageType.rollbackReadyNote':
    'Rollback snapshot point SNAP-20260920-V2 ready. One-click rollback supported.',
  'pages.standards.messageType.migrateSourcePlaceholder':
    'Select baseline version',
  'pages.standards.messageType.migrateTargetPlaceholder':
    'Select target version',

  // P-11
  'pages.messages.query.simulatedTag': 'SIMULATED',
  'pages.messages.query.includeSimulated': 'Include Simulated Messages',
  'pages.messages.query.collapseFilter': 'Collapse Filters ▲',
  'pages.messages.query.expandFilter': 'Expand Filters ▼',
  'pages.messages.query.summaryHashLabel': 'Hash: ',

  // P-12
  'pages.messages.detail.modal.targetPartner': 'Receiver Partner',
  'pages.messages.detail.modal.idempotencyResult': 'Idempotency Check Result',
  'pages.messages.detail.modal.idempotencyPassed': 'PASSED',
  'pages.messages.detail.modal.idempotencyDetail':
    'Idempotency key verified (Message-ID: {msgId}), no replay conflict detected. Safe to resend.',
  'pages.messages.detail.modal.receiverAckPolicy': 'Receiver ACK Policy',
  'pages.messages.detail.modal.transportAckLabel': 'Transport ACK: ',
  'pages.messages.detail.modal.syntaxAckLabel': 'Syntax ACK: ',
  'pages.messages.detail.modal.appAckLabel': 'Application ACK: ',
  'pages.messages.detail.modal.timeoutMins': 'Declared (Timeout {minutes} min)',
  'pages.messages.detail.modal.notDeclared': 'Not Declared',
  'pages.messages.detail.modal.lastSendInfo': 'Last Send Time & Result',
  'pages.messages.detail.modal.reasonRequired': 'Please enter resend reason',
  'pages.messages.detail.modal.createWorkorderTitle':
    'Create Incident Workorder',
  'pages.messages.detail.modal.defaultWorkorderTitle':
    'Investigate Message Anomaly {msgId}',
  'pages.messages.detail.modal.workorderSuccessWithNo':
    'Workorder {no} created successfully',
  'pages.messages.detail.modal.workorderSuccess':
    'Workorder created successfully',
  'pages.messages.detail.modal.createNow': 'Create Now',
  'pages.messages.detail.modal.relatedMessageLabel': 'Related Message: ',
  'pages.messages.detail.modal.workorderTitlePlaceholder': 'Workorder title',
  'pages.messages.detail.relations.alertTitle':
    'Business Document Message Lifecycle Chain',
  'pages.messages.detail.relations.alertDesc':
    'Business Doc {docNo} contains full lifecycle interactions. Click to trace.',
  'pages.messages.detail.relations.traceBtn': 'Trace Details',
  'pages.messages.detail.parentBatchTitle': 'Parent Batch Message Association',
  'pages.messages.detail.parentBatchDesc':
    'Generated from split composite batch:',
  'pages.messages.detail.childBatchTitle': 'Child Messages Included in Batch',
  'pages.messages.detail.childBatchDesc':
    'This batch contains the following sub-messages:',

  // P-22
  'pages.messages.batch.title': 'Batch Message Processing',
  'pages.messages.batch.desc':
    'Manage outbound batch aggregation and inbound message splitting with consistency validation.',
  'pages.messages.batch.tabOutbound': 'Outbound Aggregation',
  'pages.messages.batch.tabInbound': 'Inbound Splitting',
  'pages.messages.batch.tabHistory': 'Batch Records',
  'pages.messages.batch.outboundNoticeTitle': 'Outbound Aggregation Rules',
  'pages.messages.batch.outboundNoticeDesc':
    'Strict consistency validation enforced: receiver partner and standard version must match across all selected messages.',
  'pages.messages.batch.candidateListTitle': 'Pending Outbound Pool',
  'pages.messages.batch.selectedCount': '{count} selected',
  'pages.messages.batch.btnPreviewMerge': 'Preview Batch Merge',
  'pages.messages.batch.partnerMismatch':
    'Partner mismatch! All messages in a batch must share the same receiver partner.',
  'pages.messages.batch.versionMismatch':
    'Standard version mismatch! All messages must use the same standard version.',
  'pages.messages.batch.mergeSuccess':
    'Outbound batch created and entered transmission pipeline',
  'pages.messages.batch.inboundNoticeTitle': 'Inbound Message Splitting',
  'pages.messages.batch.inboundNoticeDesc':
    'Split composite inbound messages into standalone child messages with bi-directional relations.',
  'pages.messages.batch.selectInboundBatch': 'Select Inbound Batch:',
  'pages.messages.batch.btnSplitSelected': 'Split Selected ({count})',
  'pages.messages.batch.btnSplitAll': 'Split All',
  'pages.messages.batch.splitSuccess':
    'Batch split completed with bi-directional associations',
  'pages.messages.batch.batchMetaTitle': 'Batch Metadata & Sub-messages',
  'pages.messages.batch.totalSubTag': '{count} messages',
  'pages.messages.batch.metaPartner': 'Partner',
  'pages.messages.batch.metaVersion': 'Standard Version',
  'pages.messages.batch.metaTime': 'Received Time',
  'pages.messages.batch.emptyInbound': 'No inbound batches available for split',
  'pages.messages.batch.batchRecordsTitle': 'Batch History Records',
  'pages.messages.batch.subMessagesOverview':
    'Sub-messages (Click to view detail):',
  'pages.messages.batch.ticketsUnit': 'items',
  'pages.messages.batch.col.docNo': 'Business Doc No.',
  'pages.messages.batch.col.partner': 'Receiver Partner',
  'pages.messages.batch.col.msgType': 'Message Type',
  'pages.messages.batch.col.stdVersion': 'Standard Version',
  'pages.messages.batch.col.size': 'Estimated Size',
  'pages.messages.batch.col.createdAt': 'Created At',
  'pages.messages.batch.col.status': 'Status',
  'pages.messages.batch.statusPending': 'Pending',
  'pages.messages.batch.statusBatched': 'Batched',
  'pages.messages.batch.list.batchNo': 'Batch No.',
  'pages.messages.batch.list.direction': 'Direction',
  'pages.messages.batch.outboundTag': 'Outbound Merge',
  'pages.messages.batch.inboundTag': 'Inbound Split',
  'pages.messages.batch.list.partner': 'Partner',
  'pages.messages.batch.list.msgType': 'Message Type',
  'pages.messages.batch.list.controlNo': 'Control No.',
  'pages.messages.batch.list.subCount': 'Sub Count',
  'pages.messages.batch.list.size': 'Payload Size',
  'pages.messages.batch.list.time': 'Action Time',
  'pages.messages.batch.list.operator': 'Operator',
  'pages.messages.batch.list.status': 'Process Status',
  'pages.messages.batch.statusCompleted': 'COMPLETED',
  'pages.messages.batch.subCol.msgId': 'Sub Message ID',
  'pages.messages.batch.subCol.docNo': 'Doc No.',
  'pages.messages.batch.subCol.msgType': 'Message Type',
  'pages.messages.batch.subCol.validation': 'Validation Status',
  'pages.messages.batch.valSuccess': 'Passed',
  'pages.messages.batch.valWarn': 'Warning',
  'pages.messages.batch.subCol.size': 'Size',
  'pages.messages.batch.modal.mergeTitle': 'Outbound Batch Confirmation',
  'pages.messages.batch.modal.btnConfirmMerge': 'Confirm and Send Batch',
  'pages.messages.batch.modal.mergeSummary':
    'Consistency check passed! Will aggregate into 1 batch with {count} messages.',
  'pages.messages.batch.modal.partnerLabel': 'Receiver Partner',
  'pages.messages.batch.modal.versionLabel': 'Standard & Version',
  'pages.messages.batch.modal.controlNoLabel': 'Control Number',
  'pages.messages.batch.modal.estSizeLabel': 'Estimated Size',
  'pages.messages.batch.modal.reasonLabel': 'Operation Reason',
  'pages.messages.batch.modal.defaultReason':
    'Pre-departure batch transmission',

  // P-23
  'pages.messages.archive.title': 'Archive & Storage',
  'pages.messages.archive.desc':
    'Manage hot/cold storage tiers, archive lifecycle tasks, secure cold data reload, and compliance drills.',
  'pages.messages.archive.btnApplyReload': 'Request Cold Data Reload',
  'pages.messages.archive.wormNoticeTitle': 'Immutable WORM Compliance Policy',
  'pages.messages.archive.wormNoticeDesc':
    'Per international maritime exchange regulations: all archived data is protected by hardware WORM for 7 years (2555 days). Disabling WORM or shortening retention is strictly prohibited.',
  'pages.messages.archive.hotStorageTitle': 'Hot Tier Storage',
  'pages.messages.archive.coldStorageTitle': 'Cold Tier Storage',
  'pages.messages.archive.messageCountLabel': 'Total Messages: ',
  'pages.messages.archive.earliestLabel': 'Earliest: ',
  'pages.messages.archive.monthlyTasksTitle': 'Monthly Tasks',
  'pages.messages.archive.failCountTag': '{count} failed',
  'pages.messages.archive.latestTaskLabel': 'Latest: ',
  'pages.messages.archive.archiveStatusLabel': 'Task Status: Normal',
  'pages.messages.archive.retentionSummaryTitle':
    'Legal Retention Policy (Read-Only)',
  'pages.messages.archive.retentionYearsLabel': 'Retention Period: ',
  'pages.messages.archive.yearsUnit': 'Years (2555 days, locked)',
  'pages.messages.archive.encryptionLabel': 'Encryption: ',
  'pages.messages.archive.wormStatusLabel': 'WORM Status: ',
  'pages.messages.archive.wormActiveTag': 'Active (Hardware Locked)',
  'pages.messages.archive.tabTasks': 'Archive Tasks',
  'pages.messages.archive.tabDrills': 'Recovery Drills',
  'pages.messages.archive.drillsNotice':
    'Historical recovery drill logs and hash integrity verification for compliance audit.',
  'pages.messages.archive.btnNewDrill': 'Initiate Recovery Drill',
  'pages.messages.archive.retrySuccess': 'Archive task restarted successfully',
  'pages.messages.archive.reloadSuccess':
    'Cold data reload completed. Messages accessible in P-11 query.',
  'pages.messages.archive.drillSuccess': 'Recovery drill logged successfully',
  'pages.messages.archive.task.no': 'Task No.',
  'pages.messages.archive.task.type': 'Type',
  'pages.messages.archive.taskTypeHotToCold': 'Hot-to-Cold Archive',
  'pages.messages.archive.taskTypeReload': 'Cold Data Reload',
  'pages.messages.archive.task.range': 'Data Range',
  'pages.messages.archive.task.count': 'Count',
  'pages.messages.archive.task.startTime': 'Start Time',
  'pages.messages.archive.task.status': 'Status',
  'pages.messages.archive.taskStatusSuccess': 'Completed',
  'pages.messages.archive.taskStatusFailed': 'Failed (Hover for detail)',
  'pages.messages.archive.taskStatusRunning': 'Running',
  'pages.messages.archive.task.operator': 'Operator / Trigger',
  'pages.messages.archive.task.actions': 'Actions',
  'pages.messages.archive.btnRetry': 'Retry',
  'pages.messages.archive.btnViewLogs': 'View Logs',
  'pages.messages.archive.drill.no': 'Drill No.',
  'pages.messages.archive.drill.time': 'Drill Time',
  'pages.messages.archive.drill.scope': 'Scope',
  'pages.messages.archive.drill.count': 'Sample Count',
  'pages.messages.archive.drill.duration': 'Duration',
  'pages.messages.archive.drill.hash': 'Hash Integrity',
  'pages.messages.archive.hashPassed': 'Integrity Verified',
  'pages.messages.archive.hashFailed': 'Integrity Failed',
  'pages.messages.archive.drill.result': 'Result',
  'pages.messages.archive.drillPassed': 'PASSED',
  'pages.messages.archive.drill.operator': 'Operator',
  'pages.messages.archive.reloadModalTitle': 'Request Cold Data Reload',
  'pages.messages.archive.btnConfirmReload': 'Submit Reload Request',
  'pages.messages.archive.reloadNoticeTitle': 'Reload Mechanism & Access Info',
  'pages.messages.archive.reloadNoticeDesc':
    'Reload takes approx. 15 minutes. Once restored, messages have 7-day read-only access in P-11.',
  'pages.messages.archive.reloadTimeRange': 'Requested Time Range',
  'pages.messages.archive.reloadReason': 'Reason & Audit Approval No.',
  'pages.messages.archive.reloadReasonRequired':
    'Please specify reason and approval basis',
  'pages.messages.archive.reloadReasonPlaceholder':
    'e.g., Customs inspection, Approval: AUDIT-2026-0889',
  'pages.messages.archive.logModalTitle': 'Archive Task Execution Log',
  'pages.messages.archive.logTaskNo': 'Task No.',
  'pages.messages.archive.logType': 'Type',
  'pages.messages.archive.logStatus': 'Status',
  'pages.messages.archive.logError': 'Error Log',
  'pages.messages.archive.logRetry': 'Retry History',
  'pages.messages.archive.retryCountText': 'Retried {count} times',
  'pages.messages.archive.drillModalTitle': 'Initiate Recovery Drill',
  'pages.messages.archive.btnStartDrill': 'Start Drill',
  'pages.messages.archive.drillScope': 'Drill Scope & Batch',
  'pages.messages.archive.defaultDrillScope':
    '2025 Booking Messages Random Sample (8000)',

  // Transformation Workbench
  'pages.workflow.port.title': 'Port Settings',
  'pages.workflow.port.description': 'Port Description',
  'pages.workflow.port.mappingSection': 'Mapping',
  'pages.workflow.port.colSource': 'Source',
  'pages.workflow.port.dragToConnect':
    'Drag to a target field to map, or click this row then the target field',
  'pages.workflow.port.colTarget': 'Target',
  'pages.workflow.port.rowScript': 'Script',
  'pages.workflow.port.opExpression': 'Value Expression',
  'pages.workflow.port.opFilter': 'Filter',
  'pages.workflow.port.opScript': 'Script',
  'pages.workflow.port.opDelete': 'Delete Row',
  'pages.workflow.editor.openPort': 'Open Port Settings & Mapping',
  'pages.workflow.editor.confirm': 'Confirm',
  'pages.workflow.editor.cancel': 'Cancel',
  'pages.workflow.port.back': 'Back to Flow',
  'pages.workflow.port.subtitle':
    'Message-centric visual debugger and mapping designer',
  'pages.workflow.port.perspective': 'Perspective',
  'pages.workflow.port.perspectiveBaseline':
    'Baseline Mapping (Standard Version)',
  'pages.workflow.port.perspectivePartner': '{name} ({count} overrides)',
  'pages.workflow.port.overrideNotice':
    'Currently viewing [{partner}] perspective with {count} partner overrides applied (highlighted border and tag)',
  'pages.workflow.port.batchRegression': 'Batch Regression',
  'pages.workflow.port.publish': 'Publish Rules',
  'pages.workflow.port.save': 'Save Draft',
  'pages.workflow.port.saveSuccess': 'Baseline mapping saved',
  'pages.workflow.port.clearLineage': 'Clear Lineage Focus',
  'pages.workflow.port.activeFocus': 'Lineage Focus: {name}',
  'pages.workflow.port.sourceTitle': 'EDI Source Message',
  'pages.workflow.port.sourceSample': 'Sample Library',
  'pages.workflow.port.sourceUpload': 'Local Upload',
  'pages.workflow.port.sourceProd': 'Load from Production',
  'pages.workflow.port.selectSamplePlaceholder': 'Select sample message',
  'pages.workflow.port.uploadDraggerText':
    'Click or drag message file here (.edi, .txt)',
  'pages.workflow.port.uploadSuccess': 'Loaded local message: {name}',
  'pages.workflow.port.prodMsgIdPlaceholder':
    'Enter message ID (e.g. MSG-20260921-08832)',
  'pages.workflow.port.prodLoadBtn': 'Load',
  'pages.workflow.port.prodLoadSuccess':
    'Loaded message {id} from production environment',
  'pages.workflow.port.segmentCount': '{count} segments',
  'pages.workflow.port.unusedTag': 'Unused',
  'pages.workflow.port.unusedAlert':
    'This segment is not used by any rule! Potential mapping omission.',
  'pages.workflow.port.unusedCreateRule': 'Create Rule for Segment',
  'pages.workflow.port.flowsToCount': 'Flows to {count} fields',
  'pages.workflow.port.segmentElements': 'Data Elements Breakdown',
  'pages.workflow.port.lineNo': 'Line',
  'pages.workflow.port.rulesTitle': 'Target Rules Tree',
  'pages.workflow.port.addRule': 'Add Rule',
  'pages.workflow.port.expandAll': 'Expand All',
  'pages.workflow.port.collapseAll': 'Collapse All',
  'pages.workflow.port.ruleTypeDirect': 'Direct Mapping',
  'pages.workflow.port.ruleTypeLoop': 'Loop Mapping',
  'pages.workflow.port.ruleTypeConditional': 'Conditional Mapping',
  'pages.workflow.port.ruleTypeAggregation': 'Aggregation Mapping',
  'pages.workflow.port.ruleTypeExpression': 'Expression Mapping',
  'pages.workflow.port.ruleTypeDirectDesc':
    'Scalar 1-to-1 path with optional type conversion',
  'pages.workflow.port.ruleTypeLoopDesc':
    'Source segment group repeating to target collection with scope drilldown',
  'pages.workflow.port.ruleTypeConditionalDesc':
    'Branch by qualifier or expression to resolve reused segments (e.g. NAD by 3035)',
  'pages.workflow.port.ruleTypeAggregationDesc':
    'Reduce multiple source nodes to single value (SUM/CONCAT/FIRST/LAST)',
  'pages.workflow.port.ruleTypeExpressionDesc':
    'Script sandbox for complex logic (Groovy / JavaScript)',
  'pages.workflow.port.ruleRequired': 'Required',
  'pages.workflow.port.ruleUnmapped': 'Unmapped',
  'pages.workflow.port.ruleMapped': 'Mapped',
  'pages.workflow.port.drilldownScope': 'Drilldown Scope',
  'pages.workflow.port.exitScope': 'Exit Scope',
  'pages.workflow.port.currentScope': 'Current Scope: {scope}',
  'pages.workflow.port.scopeInstance': 'Instance: {instance}',
  'pages.workflow.port.scopeBreadcrumbRoot': 'Root Message',
  'pages.workflow.port.scopeBreadcrumbLoop': 'Loop: {name}',
  'pages.workflow.port.overrideTag': 'Partner Override',
  'pages.workflow.port.baselineTag': 'Baseline',
  'pages.workflow.port.revertBaseline': 'Revert to Baseline',
  'pages.workflow.port.revertSuccess':
    'Reverted to default baseline configuration',
  'pages.workflow.port.editRule': 'Edit',
  'pages.workflow.port.deleteRule': 'Delete',
  'pages.workflow.port.deleteConfirm':
    'Delete this rule? Result will be recalculated immediately.',
  'pages.workflow.port.inPlaceCreate': 'Create Rule In-place',
  'pages.workflow.port.ruleDrawerTitleEdit': 'Edit Transformation Rule',
  'pages.workflow.port.ruleDrawerTitleCreate': 'New Transformation Rule',
  'pages.workflow.port.fieldTargetPath': 'Target Field Path',
  'pages.workflow.port.fieldRuleName': 'Rule Name',
  'pages.workflow.port.fieldRuleType': 'Rule Type',
  'pages.workflow.port.fieldSourcePath': 'Source Path',
  'pages.workflow.port.fieldTransform': 'Transform / Function',
  'pages.workflow.port.fieldConditionQualifier':
    'Qualifier Field (e.g. NAD/3035)',
  'pages.workflow.port.fieldConditionBranches': 'Condition Branches',
  'pages.workflow.port.fieldAggMethod': 'Aggregation Method',
  'pages.workflow.port.fieldExpressionScript': 'Expression Script (Groovy/JS)',
  'pages.workflow.port.saveAndRecalc': 'Save & Recalculate',
  'pages.workflow.port.ruleSaved':
    'Rule updated, transformation result recalculated!',
  'pages.workflow.port.resultTitle': 'Transformation Result (Internal Model)',
  'pages.workflow.port.viewStructured': 'Structured View',
  'pages.workflow.port.viewRawJson': 'Raw JSON',
  'pages.workflow.port.recalculatedTag': 'Live Recalculated',
  'pages.workflow.port.latencyMs': '{ms}ms',
  'pages.workflow.port.updatedBadge': 'Updated',
  'pages.workflow.port.requiredUnmappedError':
    'Required field is not mapped by any rule',
  'pages.workflow.port.clickToCreateInPlace': 'Click to create rule in-place',
  'pages.workflow.port.issuesTitle': 'Errors & Warnings',
  'pages.workflow.port.issuesCount':
    '{errorCount} errors, {warnCount} warnings',
  'pages.workflow.port.noIssues':
    'No issues found, validation passed successfully',
  'pages.workflow.port.lineageFrom': 'Source: {source}',
  'pages.workflow.port.lineageVia': 'Via Rule: {rule}',
  'pages.workflow.port.regressionTitle': 'Sample Library Batch Regression',
  'pages.workflow.port.regressionSubtitle':
    'Run batch transformation check against all bound samples',
  'pages.workflow.port.regressionRunAll': 'Rerun Full Regression',
  'pages.workflow.port.regressionPassRate':
    'Pass Rate: {rate}% ({passed}/{total})',
  'pages.workflow.port.regressionSuccess':
    'All regression samples passed successfully!',
  'pages.workflow.port.regressionFailedAlert':
    'Failed regression samples detected! All must pass prior to publication.',
  'pages.workflow.port.colSampleName': 'Sample Name',
  'pages.workflow.port.colDuration': 'Duration',
  'pages.workflow.port.colResult': 'Result',
  'pages.workflow.port.colDetail': 'Error & Diff Detail',
  'pages.workflow.port.colAction': 'Action',
  'pages.workflow.port.loadSampleToWorkbench': 'Debug in Workbench',
  'pages.workflow.port.publishBlockedTitle': 'Publish Blocked',
  'pages.workflow.port.publishBlockedDesc':
    'Mapping rules do not meet publication criteria. Please resolve blocking items:',
  'pages.workflow.port.publishBlockedUnmapped':
    'Unmapped required target fields: {fields}',
  'pages.workflow.port.publishBlockedRegression':
    'Batch regression failed ({failedCount} failed test cases)',
  'pages.workflow.port.publishSuccess':
    'Mapping rules published successfully! New version released.',
  'pages.workflow.port.closeModal': 'Close',

  // Flow & Ports

  'pages.workflow.role.SOURCE': 'Source',
  'pages.workflow.role.PROCESSOR': 'Processor',
  'pages.workflow.role.SINK': 'Sink',
  'pages.workflow.role.ANY': 'Any',

  'pages.workflow.trigger.ACTIVE': 'Active',
  'pages.workflow.trigger.PASSIVE': 'Passive',
  'pages.workflow.trigger.MANUAL': 'Manual',
  'pages.workflow.trigger.SCHEDULED': 'Scheduled',

  'pages.workflow.list.title': 'Workflow List',
  'pages.workflow.list.subtitle':
    'Manage end-to-end integration flows and connection topologies',
  'pages.workflow.list.colName': 'Workflow Name',
  'pages.workflow.list.colDirection': 'Direction',
  'pages.workflow.list.colPartner': 'Partner',
  'pages.workflow.list.colPortCount': 'Port Count',
  'pages.workflow.list.colStatus': 'Status',
  'pages.workflow.list.colLast7dCount': 'Last 7 Days Volume',
  'pages.workflow.list.colLast7dFailed': 'Last 7 Days Failed',
  'pages.workflow.list.colUpdatedAt': 'Updated At',
  'pages.workflow.list.searchPlaceholder': 'Search workflow name or partner...',
  'pages.workflow.list.directionInbound': 'Inbound',
  'pages.workflow.list.directionOutbound': 'Outbound',
  'pages.workflow.list.statusEnabled': 'Enabled',
  'pages.workflow.list.statusDisabled': 'Disabled',
  'pages.workflow.list.statusDraft': 'Draft',
  'pages.workflow.list.actionDetail': 'View Detail',

  'pages.workflow.detail.title': 'Workflow Detail',
  'pages.workflow.detail.back': 'Back to Workflow List',
  'pages.workflow.detail.basicInfo': 'Basic Information',
  'pages.workflow.detail.stats7d': 'Last 7 Days Statistics',
  'pages.workflow.detail.canvasTitle': 'Workflow Topology Canvas',
  'pages.workflow.detail.canvasSubtitle':
    'Drag ports from the palette, connect handles to link them, then save your changes',
  'pages.workflow.detail.drawerTitle': 'Port Instance Details',
  'pages.workflow.detail.portName': 'Instance Name',
  'pages.workflow.detail.portType': 'Port Type',
  'pages.workflow.detail.portStatus': 'Status',
  'pages.workflow.detail.upstreamPorts': 'Upstream Ports',
  'pages.workflow.detail.downstreamPorts': 'Downstream Ports',
  'pages.workflow.detail.noUpstream': 'No upstream ports (Workflow Source)',
  'pages.workflow.detail.noDownstream': 'No downstream ports (Workflow Sink)',
  'pages.workflow.detail.statusRunning': 'Running',
  'pages.workflow.detail.statusStopped': 'Stopped',
  'pages.workflow.detail.statusError': 'Error',
  'pages.workflow.detail.pathSuccess': 'Success Path',
  'pages.workflow.detail.pathBranch': 'Branch Path',
  'pages.workflow.detail.pathError': 'Error Path',
  'pages.workflow.detail.emptyFlow': 'Workflow not found or data is empty',

  'pages.workflow.category.CORE': 'Core',
  'pages.workflow.category.MFT': 'Managed File Transfer (MFT)',
  'pages.workflow.category.EDI': 'Electronic Data Interchange (EDI)',
  'pages.workflow.category.DATABASE': 'Database',
  'pages.workflow.category.OTHER': 'Other',

  'pages.workflow.editor.save': 'Save',
  'pages.workflow.editor.saving': 'Saving...',
  'pages.workflow.editor.saveSuccess': 'Workflow saved successfully',
  'pages.workflow.editor.unsavedChanges': 'Unsaved Changes',
  'pages.workflow.editor.reset': 'Reset',
  'pages.workflow.editor.resetConfirmTitle': 'Confirm Reset Canvas',
  'pages.workflow.editor.resetConfirmContent':
    'Are you sure you want to discard all unsaved changes and reload?',
  'pages.workflow.editor.leaveConfirmTitle': 'Unsaved Changes',
  'pages.workflow.editor.leaveConfirmContent':
    'Current workflow has unsaved changes. Are you sure you want to leave?',
  'pages.workflow.editor.leaveConfirmOk': 'Leave',
  'pages.workflow.editor.leaveConfirmCancel': 'Stay',
  'pages.workflow.editor.paletteTitle': 'Port Library',
  'pages.workflow.editor.searchPortPlaceholder':
    'Search port type by name or ID...',
  'pages.workflow.editor.dragTip': 'Drag port into canvas to instantiate',
  'pages.workflow.editor.noMatchingPorts': 'No matching port types found',
  'pages.workflow.editor.invalidSelfLoop': 'Cannot connect a port to itself',
  'pages.workflow.editor.invalidConnectFromSink':
    'SINK ports do not support outgoing connections',
  'pages.workflow.editor.invalidConnectToSource':
    'SOURCE ports do not accept incoming connections',
  'pages.workflow.editor.invalidDuplicateConnection':
    'A connection between these ports already exists',
  'pages.workflow.editor.branchNotAllowed':
    'Only ports that support branching (e.g. Branch) can have BRANCH connections',
  'pages.workflow.editor.branchLabelRequired':
    'Branch label is required for branch connections',
  'pages.workflow.editor.branchLabelPlaceholder':
    'Enter branch condition label (e.g. Volume > 20)',
  'pages.workflow.editor.portDrawerTitle': 'Port Configuration',
  'pages.workflow.editor.edgeDrawerTitle': 'Connection Configuration',
  'pages.workflow.editor.sourcePort': 'Source Port',
  'pages.workflow.editor.targetPort': 'Target Port',
  'pages.workflow.editor.edgeType': 'Connection Type',
  'pages.workflow.editor.branchLabel': 'Branch Label',
  'pages.workflow.editor.deletePort': 'Delete Port',
  'pages.workflow.editor.deleteEdge': 'Delete Connection',
  'pages.workflow.editor.deletePortConfirm':
    'Are you sure you want to delete this port and its connections?',
  'pages.workflow.editor.deleteEdgeConfirm':
    'Are you sure you want to delete this connection?',
  'pages.workflow.editor.labelPending': 'Pending Label',
  'pages.workflow.editor.configSection': 'Configuration',
  'pages.workflow.editor.noConfigFields':
    'No configurable fields for this port type yet',
  'pages.workflow.editor.openWorkbench': 'Open Transformation Workbench',

  'pages.workflow.cfg.sourceTemplate': 'Source Template',
  'pages.workflow.cfg.targetTemplate': 'Target Template',
  'pages.workflow.cfg.mappingVersion': 'Mapping Version',
  'pages.workflow.cfg.encoding': 'Encoding',
  'pages.workflow.cfg.condition': 'Branch Condition',
  'pages.workflow.cfg.defaultBranch': 'Default Branch',
  'pages.workflow.cfg.splitMode': 'Split Mode',
  'pages.workflow.cfg.delimiter': 'Delimiter',
  'pages.workflow.cfg.maxBatchSize': 'Max Batch Size',
  'pages.workflow.cfg.mergeKey': 'Merge Key',
  'pages.workflow.cfg.mergeWindow': 'Merge Window',
  'pages.workflow.cfg.ruleSet': 'Rule Set',
  'pages.workflow.cfg.checkLevel': 'Check Level',
  'pages.workflow.cfg.failurePolicy': 'Failure Policy',
  'pages.workflow.cfg.scriptFile': 'Script File',
  'pages.workflow.cfg.scriptLang': 'Script Language',
  'pages.workflow.cfg.timeoutMs': 'Timeout (ms)',
  'pages.workflow.cfg.cron': 'Cron Expression',
  'pages.workflow.cfg.timezone': 'Timezone',
  'pages.workflow.cfg.hasHeader': 'Has Header',
  'pages.workflow.cfg.quoteChar': 'Quote Char',
  'pages.workflow.cfg.rootPath': 'Root Path',
  'pages.workflow.cfg.outputFormat': 'Output Format',
  'pages.workflow.cfg.fieldLength': 'Field Length',
  'pages.workflow.cfg.padChar': 'Pad Char',
  'pages.workflow.cfg.channel': 'Channel',
  'pages.workflow.cfg.recipients': 'Recipients',
  'pages.workflow.cfg.notifyLevel': 'Notify Level',
  'pages.workflow.cfg.targetPath': 'Target Path',
  'pages.workflow.cfg.overwrite': 'Overwrite',
  'pages.workflow.cfg.discardReason': 'Discard Reason',
  'pages.workflow.cfg.logDiscard': 'Log Discarded',
  'pages.workflow.cfg.endpoint': 'Endpoint',
  'pages.workflow.cfg.as2Id': 'AS2 ID',
  'pages.workflow.cfg.certAlias': 'Certificate Alias',
  'pages.workflow.cfg.retryCount': 'Retry Count',
  'pages.workflow.cfg.host': 'Host',
  'pages.workflow.cfg.port': 'Port',
  'pages.workflow.cfg.username': 'Username',
  'pages.workflow.cfg.remoteDir': 'Remote Directory',
  'pages.workflow.cfg.privateKeyAlias': 'Private Key Alias',
  'pages.workflow.cfg.rootDir': 'Root Directory',
  'pages.workflow.cfg.allowedUsers': 'Allowed Users',
  'pages.workflow.cfg.bucket': 'Bucket',
  'pages.workflow.cfg.prefix': 'Object Prefix',
  'pages.workflow.cfg.region': 'Region',
  'pages.workflow.cfg.credentialAlias': 'Credential Alias',
  'pages.workflow.cfg.pgpOperation': 'PGP Operation',
  'pages.workflow.cfg.keyAlias': 'Key Alias',
  'pages.workflow.cfg.algorithm': 'Algorithm',
  'pages.workflow.cfg.messageType': 'Message Type',
  'pages.workflow.cfg.version': 'Version',
  'pages.workflow.cfg.declareType': 'Declaration Type',
  'pages.workflow.cfg.companyCode': 'Company Code',
  'pages.workflow.cfg.receiptTimeout': 'Receipt Timeout',
  'pages.workflow.cfg.connection': 'Connection',
  'pages.workflow.cfg.operation': 'Operation',
  'pages.workflow.cfg.table': 'Table',
  'pages.workflow.cfg.schema': 'Schema',
  'pages.workflow.cfg.topic': 'Topic',
  'pages.workflow.cfg.groupId': 'Consumer Group',
  'pages.workflow.cfg.partitionKey': 'Partition Key',
  'pages.workflow.cfg.exchange': 'Exchange',
  'pages.workflow.cfg.routingKey': 'Routing Key',
  'pages.workflow.cfg.queue': 'Queue',
  'pages.workflow.cfg.url': 'URL',
  'pages.workflow.cfg.method': 'Method',
  'pages.workflow.cfg.authMode': 'Auth Mode',
  'pages.workflow.cfg.webhookPath': 'Webhook Path',
  'pages.workflow.cfg.signSecretAlias': 'Signing Secret Alias',

  'pages.workflow.cfgOpt.ynYes': 'Yes',
  'pages.workflow.cfgOpt.ynNo': 'No',
  'pages.workflow.cfgOpt.encUtf8': 'UTF-8',
  'pages.workflow.cfgOpt.encGbk': 'GBK',
  'pages.workflow.cfgOpt.encLatin1': 'ISO-8859-1',
  'pages.workflow.cfgOpt.fmtXml': 'XML',
  'pages.workflow.cfgOpt.fmtJson': 'JSON',
  'pages.workflow.cfgOpt.opQuery': 'Query',
  'pages.workflow.cfgOpt.opWrite': 'Write',
  'pages.workflow.cfgOpt.opProc': 'Stored Procedure',
  'pages.workflow.cfgOpt.brError': 'Route to error path',
  'pages.workflow.cfgOpt.brDiscard': 'Discard',
  'pages.workflow.cfgOpt.splitLine': 'By line',
  'pages.workflow.cfgOpt.splitRecord': 'By record',
  'pages.workflow.cfgOpt.splitDelimiter': 'By delimiter',
  'pages.workflow.cfgOpt.lvlStrict': 'Strict',
  'pages.workflow.cfgOpt.lvlLoose': 'Loose',
  'pages.workflow.cfgOpt.lvlError': 'Errors only',
  'pages.workflow.cfgOpt.lvlWarn': 'Warnings and above',
  'pages.workflow.cfgOpt.lvlAll': 'All',
  'pages.workflow.cfgOpt.failAbort': 'Abort flow',
  'pages.workflow.cfgOpt.failWarn': 'Warn and continue',
  'pages.workflow.cfgOpt.langGroovy': 'Groovy',
  'pages.workflow.cfgOpt.langJs': 'JavaScript',
  'pages.workflow.cfgOpt.langPython': 'Python',
  'pages.workflow.cfgOpt.tzShanghai': 'Asia/Shanghai',
  'pages.workflow.cfgOpt.tzUtc': 'UTC',
  'pages.workflow.cfgOpt.tzTokyo': 'Asia/Tokyo',
  'pages.workflow.cfgOpt.tzLondon': 'Europe/London',
  'pages.workflow.cfgOpt.chEmail': 'Email',
  'pages.workflow.cfgOpt.chSms': 'SMS',
  'pages.workflow.cfgOpt.chWebhook': 'Webhook',
  'pages.workflow.cfgOpt.chWecom': 'WeCom',
  'pages.workflow.cfgOpt.pgpEncrypt': 'Encrypt',
  'pages.workflow.cfgOpt.pgpDecrypt': 'Decrypt',
  'pages.workflow.cfgOpt.pgpSign': 'Sign',
  'pages.workflow.cfgOpt.pgpVerify': 'Verify',
  'pages.workflow.cfgOpt.algAes256': 'AES-256',
  'pages.workflow.cfgOpt.algRsa2048': 'RSA-2048',
  'pages.workflow.cfgOpt.alg3des': '3DES',
  'pages.workflow.cfgOpt.mGet': 'GET',
  'pages.workflow.cfgOpt.mPost': 'POST',
  'pages.workflow.cfgOpt.mPut': 'PUT',
  'pages.workflow.cfgOpt.mDelete': 'DELETE',
  'pages.workflow.cfgOpt.authNone': 'None',
  'pages.workflow.cfgOpt.authBasic': 'Basic',
  'pages.workflow.cfgOpt.authBearer': 'Bearer',
  'pages.workflow.cfgOpt.authOauth2': 'OAuth2',
  'pages.audit.result.success': 'Success',
  'pages.audit.result.failed': 'Failed',
};
